import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core'
import { IButtonItem } from './button-group.interface'

@Component({
  selector: 'mg-button-group',
  templateUrl: './button-group.component.html',
  styleUrls: ['./button-group.component.scss'],
  standalone: false
})
export class ButtonGroupComponent {
  @Input() buttons: IButtonItem[] = []
  @Input() containerClass = ''
  @Input() itemClass = ''
  @Input() selectedButtonValue: any
  @Input() itemTemplate: TemplateRef<any> | null = null

  @Output() selectedButtonChanged = new EventEmitter()

  onButtonClick(item: IButtonItem) {
    if (item.disabled) return
    this.selectedButtonValue = item.value
    this.selectedButtonChanged.emit(item.value)
  }
}
